module.exports = __webpack_public_path__ + "img/logo.16abce4a.png";